import { render, staticRenderFns } from "./exhibition_tpl.vue?vue&type=template&id=528785a4&scoped=true"
import script from "./exhibition_tpl.vue?vue&type=script&lang=js"
export * from "./exhibition_tpl.vue?vue&type=script&lang=js"
import style0 from "./exhibition_tpl.vue?vue&type=style&index=0&id=528785a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528785a4",
  null
  
)

export default component.exports